<!--
This component generates the accepted list group}.
Receiver must pass an array to {acceptedList} to let the component generate the proper ui.
-->
<template>
  <div class="list-group-container">
    <div class="d-flex flex-row list-row-header">
      <div class="p-2 w-50">Name</div>
      <div class="p-2 w-25">Email Address</div>
      <div class="p-2 w-25">Date Accepted</div>
      <div class="p-2 w-25">Action</div>
    </div>

    <!-- modal details -->
    <modal v-if="isShowAcceptedModal">
      <div slot="header" class="modal-header-content">
        <button type="button" class="btn btn-x" @click="closeAcceptedModal()">x</button>
        <div class="modal-title text-center">
          <p>Guest Details</p>
          <h6></h6>
        </div>
      </div>

      <div slot="body">
        <div class="detail-title">
          <p>User information</p>
        </div>

        <ul class="detail-content" v-for="(data, index) in includedPassDetails" :key="index + 10">
          <li class="detail-content-title">{{ data }}</li>
          <li class="detail-content-value">
            {{ acceptedItem.individual_details[constructedIncludedPassDetails[index]] }}
          </li>
        </ul>

        <div v-for="(r, i) in acceptedItem.pass_access_questions_response" :key="i">
          <ul class="detail-content">
            <li class="detail-content-title">{{ r.question }}</li>
            <li class="detail-content-value">{{ r.response }}</li>
          </ul>
        </div>

        <div class="detail-title-email">
          <p>Add message to email notification</p>
        </div>

        <div class="detail-title-email-content">
          <p>TEXT FIELD HERE</p>
        </div>

        <div class="detail-title">
          <p>Pass Accepted: <span>
            {{ convertEpochTime(acceptedItem.date_created) }}
          </span></p>
        </div>
      </div>

      <div slot="footer">
        <button type="button" class="btn btn-cancel" @click="closeAcceptedModal()">
          Cancel
        </button>
        <button type="button" class="btn btn-approve" @click="sendMessage()">
          Send a message
        </button>
      </div>
    </modal>
    <!-- end modal -->

    <!--Appears if there's no accepted-->
    <div class="d-flex flex-row list-row-empty" v-if="!hasAccepted">
      <div class="flex-fill">No data yet.</div>
    </div>
    <!--end no accepted -->

    <!-- appears if with acceptedList/s -->
    <div class="list-rows" v-else>
      <div v-for="(data, index) in acceptedList" :key="index"
        class="d-flex flex-row list-row">
        <div class="px-2 w-50 list-column-item">
          {{ data.individual_details.full_name }}
        </div>
        <div class="px-2 w-25 list-column-item">
          {{ data.individual_details.email_address }}
        </div>
        <div class="px-2 w-25 list-column-item">
          {{ convertEpochTime(data.date_created) }}
        </div>
        <div class="px-2 w-25 list-column-action">
          <button class="simple-link" @click="showAcceptedModal(data, $event)">
            <i class="fas fa-info"></i>
          </button>
        </div>
      </div>
    </div>
    <!-- end with acceptedList -->
  </div>
</template>

<script>
import '@/assets/styles/list-style.css'

import Modal from '@/components/common/Modal'

export default {
  name: 'accepted-list-view',
  components: {
    Modal
  },
  data() {
    return { }
  },
  props: {
    includedPassDetails: Array,
    acceptedList: Array,
    isShowAcceptedModal: Boolean,
    hasAccepted: Boolean,
    acceptedItem: Object,
    convertEpochTime: Function,
    showAcceptedModal: Function,
    closeAcceptedModal: Function,
    sendMessage: Function
  },
  computed: {
    constructedIncludedPassDetails () {
      return this.includedPassDetails.map(d => {
        return d.split(' ').length - 1 >= 1
          ? d.toLowerCase().replace(/ /g, '_')
          : d.toLowerCase()
      })
    }
  }
}
</script>

<style scoped>
.invite-section {
  margin-top: 48px;
}
.invite-status-header {
  display:flex;
  align-items: center;
}
.invite-status-title {
  font-family: "HKGrotesk-Bold", Helvetica, sans-serif;
  color: #00386A;
  font-size: 20px;
}
.invite-status-indicator {
  width: 12px;
  height: 12px;

  border-radius: 100%;
  margin-right: 12px;
}

/* Status indicator color styles */
.status-active {
  background-color: #42BB79;
}
.status-inactive {
  background-color: #547181;
}
.status-pending {
  background-color: #EDC834;
}
</style>



// WEBPACK FOOTER //
// src/components/listview/AcceptedListView.vue